import cloneDeep from "lodash/cloneDeep";

class MedicalSummaryPanelSettings {
    public IsPreventiveActivitiesTabOpen: boolean;
    public IsPendingItemsTabOpen: boolean;
    public IsActiveProblemsTabOpen: boolean;
    public IsActiveMedicationsTabOpen: boolean;
    public IsAllergiesTabOpen: boolean;
    public IsMedicalHistoryTabOpen: boolean;
    public IsSocialHabitsTabOpen: boolean;
    public IsObstetricalHistoryTabOpen: boolean;
    public IsImmunizationsTabOpen: boolean;
    public IsFamilyHistoryTabOpen: boolean;
    public IsMedicalSummaryPanelOpen: boolean;
    public IsPsychiatricHistoryTabOpen: boolean;
    public IsSurgicalHistoryTabOpen: boolean;

    constructor(fields?: Partial<MedicalSummaryPanelSettings>) {
        this.IsPreventiveActivitiesTabOpen = false;
        this.IsPendingItemsTabOpen = false;
        this.IsActiveProblemsTabOpen = false;
        this.IsActiveMedicationsTabOpen = false;
        this.IsAllergiesTabOpen = false;
        this.IsMedicalHistoryTabOpen = false;
        this.IsSocialHabitsTabOpen = false;
        this.IsObstetricalHistoryTabOpen = false;
        this.IsImmunizationsTabOpen = false;
        this.IsFamilyHistoryTabOpen = false;
        this.IsMedicalSummaryPanelOpen = false;
        this.IsPsychiatricHistoryTabOpen = false;
        this.IsSurgicalHistoryTabOpen = false;

        Object.assign(this, fields);
    }

    /**
     * Return a deep cloned object of MedicalSummaryPanelSettings
     * @param {MedicalSummaryPanelSettings} medicalSummaryPanelSettings
     * @returns {MedicalSummaryPanelSettings}
     */
    public static getDeepClonedMedicalSummaryPanelSettings(medicalSummaryPanelSettings: MedicalSummaryPanelSettings): MedicalSummaryPanelSettings {
        if (!medicalSummaryPanelSettings) {
            return new MedicalSummaryPanelSettings();
        }
        else {
            return cloneDeep(medicalSummaryPanelSettings) as MedicalSummaryPanelSettings;
        }
    }
}

export { MedicalSummaryPanelSettings };
